import { lazy } from 'react';

import { withCampaignSavedData } from './withCampaignSavedData';

const LazyFormPagesStep03 = lazy(() =>
  import('./FormPagesStep03').then((module) => ({ default: module.FormPagesStep03 })),
);

export const EnhancedFormPagesStep03 = withCampaignSavedData(LazyFormPagesStep03);
